import Api from "../../axios";

export default async function apiAttendanceApprovalList() {
  return await Api.get(`/attendance_approval_list`);
}
